/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Name_Required_SimpleInputs */

const en_name_required_simple = /** @type {(inputs: Name_Required_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required`)
};

const es_name_required_simple = /** @type {(inputs: Name_Required_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre es obligatorio`)
};

/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Name_Required_SimpleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const name_required_simple = /** @type {((inputs?: Name_Required_SimpleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Name_Required_SimpleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_name_required_simple(inputs)
	return es_name_required_simple(inputs)
});